import { FormWithRedux } from '../../FormWithRedux';

export class GPChestPainKeyHistoricalInformationForm extends FormWithRedux {

    constructor(formIdentifier,parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super(formIdentifier, parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        if (identifier == 'noToAllProblemsAndPast' || identifier == 'noToAllMedications') {
            return this.unselectedExplicitFormDetailsCount(identifier) > 1;
        }
        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory(identifier) {
        if(identifier == 'noToAllProblemsAndPast' || identifier == 'noToAllMedications') {
            return false;
        } else if (identifier != null) {
            return true;
        }
        return false;
    }

    getValueType() {
        return 'boolean';
    }

    submissionValidation() {
        return [];
    }

    detailString(isSubform) {
        let formDetails = this.getFormDetails();
        let values = formDetails.map((value) => {
            return (value.valueDescription() == null || value.valueDescription() == false) ? null : (isSubform ? '- ' : '') + value.valueDescription();
        });

        if(values.filter(n => n).length == 0) {
            return isSubform ? '' : this.detail;
        }

        return values.filter(n => n).join(',\n');
    }

}


// WEBPACK FOOTER //
// ./src/forms/gpChestPain01/Forms/GPChestPain-KeyHistoricalInformationForm.js